jQuery(function ($) {
	$.subscribe('/event-registration/prefill-user-fields', function( event, currentUser, $form ) {

		if (!$form.length) {
			return;
		}

		const $stateField = $form.find('select[name*="state"]:first');
		if ( $stateField.length && 'postal_state' in currentUser && currentUser.postal_state) {
			$stateField.find('option[value="' + currentUser.postal_state + '"]').attr('selected', true);

			// Disable all options besides the user's postal state.
			$stateField.find('option:not(:selected)').attr('disabled', true);
			$stateField.get(0).dispatchEvent(new Event('change'));
		}

		let $businessPhone = $form.find('input[name*="office-number"]:first');
		if (!$businessPhone) {
			$businessPhone = $form.find('input[name*="landline"]:first');
		}
		if ($businessPhone.length && 'business_phone' in currentUser) {
			$businessPhone.val(currentUser.business_phone);
			$businessPhone.get(0).dispatchEvent(new Event('change'));
		}

		let $jobTitle = $form.find('input[name*="job-title"]:first');
		if (!$jobTitle) {
			$jobTitle = $form.find('input[name*="position-title"]:first');
		}
		if ($jobTitle.length && 'job_title' in currentUser) {
			$jobTitle.val(currentUser.job_title);
			$jobTitle.get(0).dispatchEvent(new Event('change'));
		}

		let $levelOfExperience = $form.find('select[name*="level-of-experience"]:first');
		if ($levelOfExperience.length) {
			if ('level_of_experience' in currentUser) {
				$levelOfExperience.find('option[value="' + currentUser.level_of_experience + '"]').attr('selected', true);
				$levelOfExperience.get(0).dispatchEvent(new Event('change'));
			}
		}

		let $areaOfSpecialisation = $form.find('select[name*="area-of-specialisation"]:first');
		if ($areaOfSpecialisation.length) {
			if ('specialisation_work_area' in currentUser) {
				$areaOfSpecialisation.find('option[value="' + currentUser.specialisation_work_area+ '"]').attr('selected', true);
				$areaOfSpecialisation.get(0).dispatchEvent(new Event('change'));
			}
		}

		let $industry = $form.find('select[name*="industry"]:first');
		if ($industry.length) {
			if ('industry' in currentUser) {
				$industry.find('option[value="' + currentUser.industry + '"]').attr('selected', true);
				$industry.get(0).dispatchEvent(new Event('change'));
			}
		}

		let $companyName = $form.find('input[name*="company-name"]:first');
		if ( $companyName.length && 'company_name' in currentUser) {
			$companyName.val(currentUser.company_name);
			$companyName.get(0).dispatchEvent(new Event('change'));
		}

		let $sector = $form.find('select[name*="sector"]:first');
		if ($sector.length) {
			if ('sector' in currentUser) {
				$sector.find('option[value="' + currentUser.sector + '"]').attr('selected', true);
				$sector.get(0).dispatchEvent(new Event('change'));
			}
		}

		let $sizeOfOrg = $form.find('select[name*="size-of-organisation"]:first');
		if ($sizeOfOrg.length) {
			if ('organisation_size' in currentUser) {
				$sizeOfOrg.find('option[value="' + currentUser.organisation_size + '"]').attr('selected', true);
				$sizeOfOrg.get(0).dispatchEvent(new Event('change'));
			}
		}
	});
});
